module.exports = __webpack_public_path__ + "static/media/theme-gallery-skeleton.74162654.png";